<template>
  <div class="view pa24">
    <!-- 客户信用记录弹窗组件 -->
   

    <!-- 客户模式：显示客户信用记录数据 -->
    <div v-if="pageMode === 'customer'">
      <!-- 客户信息显示 -->
      <div class="customer-info" style="margin-bottom: 20px; padding: 15px; background: #f5f7fa; border-radius: 4px;">
        <div style="display: flex; align-items: center; flex-wrap: wrap;">
          <span style="font-weight: bold; color: #303133;">{{$t('customer','customerName')}}：</span>
          <span style="color: #409EFF; margin-right: 20px;">{{ customerName }}</span>
          <span style="font-weight: bold; color: #303133;">{{$t('customer','customerInfoLabelRemainingCredit')}}：</span>
          <span style="color: #67C23A; font-weight: bold; margin-right: 10px;">{{ currentBalance }}</span>
          <el-button 
            type="primary" 
            size="small" 
            @click="showModifyDialog"
            icon="el-icon-edit"
          >
            {{$t('customer','buttonModifyCredit')}}
          </el-button>
        </div>
      </div>

      <!-- 客户信用记录表格 -->
      <commonTable
        :tableData="customerTableData"
        :loading="customerLoading"
        @handleSizeChange="handleCustomerSizeChange"
        @handleCurrentChange="handleCustomerCurrentChange"
        :currentPage="customerPageNum"
        :total="customerTotal"
      >
        <template v-slot:table>
          <el-table-column prop="createTimeText" :label="$t('finance','recordTime')" width="160" align="center" />
          <el-table-column prop="userName" :label="$t('customer','userName')" width="120" align="center" show-overflow-tooltip />
          <el-table-column prop="changeTypeText" :label="$t('customer','tableType')" width="120" align="center" />
          <el-table-column prop="changeAmountText" :label="$t('customer','tableChangeAmount')" width="150" align="center" />
          <el-table-column prop="balanceBeforeText" :label="$t('customer','tableBalanceBefore')" width="150" align="center" />
          <el-table-column prop="balanceAfterText" :label="$t('customer','tableBalanceAfter')" width="150" align="center" />
          <el-table-column prop="orderNo" :label="$t('customer','tableRelatedOrder')" width="200" align="center" show-overflow-tooltip />
          <el-table-column prop="remark" :label="$t('customer','tableRemark')" min-width="120" align="center" show-overflow-tooltip />
        </template>
      </commonTable>
    </div>

    <!-- 修改额度弹窗 -->
    <el-dialog
      :title="$t('customer','modifyCreditTitle')"
      :visible.sync="modifyDialogVisible"
      width="400px"
      :modal="false"
      @close="handleModifyClose"
      :center="true"
    >
      <el-form :model="modifyForm" :rules="modifyRules" ref="modifyForm" label-width="130px" label-position="left">
        <el-form-item :label="$t('customer','customerName')">
          <el-input v-model="customerName" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('customer','customerInfoLabelRemainingCredit')">
          <el-input v-model="currentBalance" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('customer','changeAmountLabel')" prop="changeAmount">
          <el-input-number
            v-model="modifyForm.changeAmount"
            :precision="2"
            :step="0.01"
            :min="-999999"
            :max="999999"
            style="width: 100%"
          ></el-input-number>
          <div style="font-size: 12px; color: #f56c6c; margin-top: 5px; text-align: center;">
            {{$t('customer','changeAmountHint')}}
          </div>
        </el-form-item>
        <el-form-item :label="$t('customer','remark')" prop="remark">
          <el-input
            v-model="modifyForm.remark"
            type="textarea"
            :rows="3"
            :placeholder="$t('customer','inputRemark')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('customer','orderNoLabel')">
          <el-input
            v-model="modifyForm.orderNo"
            :placeholder="$t('customer','orderNoPlaceholder')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="modifyDialogVisible = false">{{$t('customer','cancel')}}</el-button>
        <el-button type="primary" @click="submitModify" :loading="modifyLoading">{{$t('customer','confirm')}}</el-button>
      </div>
    </el-dialog>

    <!-- 管理页面模式：显示自己的信用记录 -->
    <div v-if="pageMode !== 'customer'">
      <div class="d-flex mb20">
        <div class="flex1">
          <el-input
            v-model="searchForm.companyName"
            :placeholder="$t('finance', 'companyNamePlaceholder')"
            style="width: 300px; margin-right: 10px;"
            clearable
          />
          <el-button type="primary" @click="searchRecords">{{ $t('common', 'search') }}</el-button>
          <el-button @click="resetSearch">{{ $t('common', 'reset') }}</el-button>
        </div>
      </div>

      <commonTable
        :tableData="tableData"
        :loading="loading"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :currentPage="currentPage"
        :total="total"
      >
        <template v-slot:table>
          <el-table-column prop="createTimeText" :label="$t('finance', 'recordTime')" width="180" align="center" />
          <el-table-column prop="userName" :label="$t('customer','userName')" width="120" align="center" show-overflow-tooltip />
          <el-table-column prop="companyName" :label="$t('finance', 'creditGrantingCompany')" width="200" align="center" show-overflow-tooltip />
          <el-table-column prop="changeTypeText" :label="$t('finance', 'changeType')" width="120" align="center" />
          <el-table-column prop="changeAmountText" :label="$t('finance', 'changeAmount')" width="150" align="center" />
          <el-table-column prop="balanceBeforeText" :label="$t('finance', 'balanceBefore')" width="150" align="center" />
          <el-table-column prop="balanceAfterText" :label="$t('finance', 'balanceAfter')" width="150" align="center" />
          <el-table-column prop="orderNo" :label="$t('finance', 'relatedOrder')" width="200" align="center" show-overflow-tooltip />
          <el-table-column prop="remark" :label="$t('finance', 'remark')" min-width="120" align="center" show-overflow-tooltip />
        </template>
      </commonTable>
    </div>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import { getCreditPaymentRecords, getCustomerInfo, modifyCreditPaymentBalance } from "@/api/client";
import { getDataTimeSec } from "@/utils/index";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  name: "creditRecordManagement",
  mixins: [i18nMixin],
  components: {
    commonTable,
  },
  data() {
    return {
      // 自己的信用记录相关
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      searchForm: {
        companyName: ''
      },
      // 页面模式：'customer' 表示客户模式，'management' 表示管理页面模式
      pageMode: 'management',
      // 客户模式相关参数
      customerCardId: null,
      customerId: null,
      customerName: '',
      currentBalance: '0.00',
      
      // 客户信用记录相关
      customerLoading: false,
      customerTableData: [],
      customerPageNum: 1,
      customerPageSize: 10,
      customerTotal: 0,
      
      // 修改额度相关
      modifyDialogVisible: false,
      modifyLoading: false,
      modifyForm: {
        changeAmount: 0,
        remark: '',
        orderNo: ''
      },
      modifyRules: {
        changeAmount: [
          { required: true, message: this.$t('customer','pleaseEnterChangeAmount'), trigger: 'blur' },
          { type: 'number', message: this.$t('customer','pleaseEnterValidNumber'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('customer','inputRemark'), trigger: 'blur' }
        ]
      }
    };
  },
  async created() {
    // 根据路由参数判断页面模式
    this.pageMode = this.$route.query.mode || 'management';
    this.customerCardId = this.$route.query.cardId || null;
    
    if (this.pageMode === 'customer' && this.customerCardId) {
      // 客户模式：获取客户信息并显示信用记录
      this.getCustomerInfo();
    } else {
      // 管理页面模式：显示自己的信用记录
      this.getRecords();
    }
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods: {
    // 获取客户信息
    getCustomerInfo() {
      if (!this.customerCardId) return;
      
      const params = {
        cardId: this.customerCardId
      };
      
      getCustomerInfo(params).then(res => {
        if (res.code === 200 && res.data) {
          this.customerName = res.data.name;
          this.customerId = res.data.customerId;
          this.currentBalance = this.formatAmount(res.data.creditPaymentBalance || 0);
          
          // 获取客户信用记录
          this.getCustomerRecords();
        }
      }).catch(err => {
        console.error(this.$t('customer','getCustomerInfoFailed') + ':', err);
      });
    },
    
    // 获取客户信用记录
    getCustomerRecords() {
      if (!this.customerId) return;
      
      this.customerLoading = true;
      const params = {
        customerId: this.customerId,
        pageNum: this.customerPageNum,
        pageSize: this.customerPageSize
      };
      
      getCreditPaymentRecords(params).then(res => {
        this.customerLoading = false;
        if (res.code === 200 && res.data && res.data.pageInfo) {
          this.customerTableData = (res.data.pageInfo.list || []).map(record => {
            return {
              ...record,
              createTimeText: this.formatTime(record.createTime),
              changeTypeText: this.getChangeTypeText(record.changeType),
              changeAmountText: this.formatAmount(record.changeAmount),
              balanceBeforeText: this.formatAmount(record.balanceBefore),
              balanceAfterText: this.formatAmount(record.balanceAfter)
            };
          });
          this.customerTotal = (res.data.pageInfo && res.data.pageInfo.total) || 0;
        } else {
          this.customerTableData = [];
          this.customerTotal = 0;
        }
      }).catch(err => {
        this.customerLoading = false;
        this.customerTableData = [];
        this.customerTotal = 0;
        this.$message.error(this.$t('customer','fetchRecordsFailed'));
      });
    },
    
    // 显示修改额度弹窗
    showModifyDialog() {
      this.modifyDialogVisible = true;
      this.modifyForm = {
        changeAmount: 0,
        remark: '',
        orderNo: ''
      };
    },
    
    // 关闭修改额度弹窗
    handleModifyClose() {
      this.modifyDialogVisible = false;
      this.$refs.modifyForm && this.$refs.modifyForm.resetFields();
    },
    
    // 提交修改额度
    submitModify() {
      this.$refs.modifyForm.validate((valid) => {
        if (valid) {
          this.modifyLoading = true;
          const params = {
            customerId: this.customerId,
            changeAmount: Math.round(this.modifyForm.changeAmount * 100),
            remark: this.modifyForm.remark,
            orderNo: this.modifyForm.orderNo || null
          };
          
          modifyCreditPaymentBalance(params).then(res => {
            this.modifyLoading = false;
            if (res.code === 200) {
              this.$message.success(this.$t('customer','modifySuccess'));
              this.modifyDialogVisible = false;
              this.getCustomerInfo(); // 重新获取客户信息和记录
            } else {
              this.$message.error(res.message || this.$t('customer','modifyFailed'));
            }
          }).catch(err => {
            this.modifyLoading = false;
            this.$message.error(this.$t('customer','modifyFailed'));
          });
        }
      });
    },
    
    // 客户记录分页
    handleCustomerSizeChange(val) {
      this.customerPageSize = val;
      this.customerPageNum = 1;
      this.getCustomerRecords();
    },
    
    handleCustomerCurrentChange(val) {
      this.customerPageNum = val;
      this.getCustomerRecords();
    },

    // 自己的信用记录相关方法
    getRecords() {
      this.loading = true;
      const params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        companyName: this.searchForm.companyName || undefined
      };
      
      getCreditPaymentRecords(params).then(res => {
        this.loading = false;
        if (res.code === 200 && res.data && res.data.pageInfo) {
          this.tableData = (res.data.pageInfo.list || []).map(record => {
            return {
              ...record,
              createTimeText: this.formatTime(record.createTime),
              changeTypeText: this.getChangeTypeText(record.changeType),
              changeAmountText: this.formatAmount(record.changeAmount),
              balanceBeforeText: this.formatAmount(record.balanceBefore),
              balanceAfterText: this.formatAmount(record.balanceAfter)
            };
          });
          this.total = (res.data.pageInfo && res.data.pageInfo.total) || 0;
        } else {
          this.tableData = [];
          this.total = 0;
        }
      }).catch(err => {
        this.loading = false;
        this.tableData = [];
        this.total = 0;
        this.$message.error(this.$t('finance', 'fetchRecordsFailed'));
      });
    },
    
    searchRecords() {
      this.currentPage = 1;
      this.getRecords();
    },
    
    resetSearch() {
      this.searchForm.companyName = '';
      this.currentPage = 1;
      this.getRecords();
    },
    
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getRecords();
    },
    
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getRecords();
    },

    // 通用方法
    getChangeTypeText(type) {
      const typeMap = {
        1: this.$t('finance', 'changeTypePurchase'),
        2: this.$t('finance', 'changeTypeRefund'),
        3: this.$t('finance', 'changeTypeAdjust'),
      };
      return typeMap[type] || this.$t('common', 'unknown');
    },
    
    formatAmount(amount) {
      if (amount === null || amount === undefined) {
        return '0.00';
      }
      return (amount / 100).toFixed(2);
    },
    
    formatTime(timeStr) {
      if (!timeStr) return '';
      return getDataTimeSec(timeStr);
    }
  }
};
</script>

<style scoped>
.credit-records {
  padding: 10px 0;
}
</style>
